// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__QYj0v","note":"styles_note__jPPy1","action":"styles_action__7oco3"};